import { render, staticRenderFns } from "./changelocation.vue?vue&type=template&id=494cfc7e&"
import script from "./changelocation.vue?vue&type=script&lang=js&"
export * from "./changelocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports